<template>
  <div>
    <Nav />
    <section class="section" id="Main" role="main">
      <div class="container">
        <h2 class="title is-2">Resources</h2>
        <div class="content">
          <p v-for="(resource,index) in resources" v-bind:key="index">
            <a :href="resource.url" :aria-label="`Visit ${resource.title}`">{{resource.title}}</a>
          </p>
        </div>
      </div>
    </section>
    <Footer />
  </div>
</template>

<script>
import Nav from "./components/Nav.vue";
import Footer from "./components/Footer.vue";
import { resources } from "./resources";
export default {
  name: "Resources",
  components: {
    Nav,
    Footer
  },
  data: function() {
    return {
      resources
    };
  },
  mounted: function() {
    this.resources.sort((a, b) => (a.title > b.title ? 1 : -1));
  }
};
</script>

<style scoped>
</style>